/** Top navigation bar showing the product mark. */

import React from "react";

export default function Navbar(): React.ReactElement {
  return (
    <header className="flex h-16 items-center justify-between border-b border-ink-700 bg-ink-950/80 px-6 backdrop-blur">
      <div className="flex items-center gap-2">
        <span className="font-display text-lg font-semibold tracking-tight text-mist-100">
          TradeMind <span className="text-signal-teal">AI X</span>
        </span>
      </div>
    </header>
  );
}
